import React from 'react';

const HomeMainPCHeader = () => {
  return (
    <>
      <h3 className="title-h3">안녕하세요! KB라이프 생명입니다.</h3>
      <p>
        상품은 각 사이트에서 설계가 가능합니다.
        <br />
        상품에 대한 정보를 알고 싶으시다면 아래 검색을 통해 확인후 이동해
        주세요.
      </p>
    </>
  );
};

export default HomeMainPCHeader;
